import React, { type FC } from 'react'
import { type FeedData } from 'pages/native/userFeed/types'
import { StartTimeInfo } from '../StartTimeInfo/StartTimeInfo'

import classes from './GameInfo.module.scss'

type GameInfoProps = {
  game: FeedData
}

export const GameInfo: FC<GameInfoProps> = ({ game }) => {
  const isInFuture = new Date(+game.startTime * 1000) > new Date()
  return (
    <div className={classes.Container}>
      <div className={classes.Title}>{game.event?.name}</div>
      {isInFuture ? (
        <div className={classes.FutureEventDate}>
          <StartTimeInfo startTime={game.startTime} isFuture={true} />
        </div>
      ) : (
        <>
          <div
            className={classes.GameScore}
          >{`${game.homeScore} - ${game.awayScore}`}</div>
          <div className={classes.PastEventDate}>
            <StartTimeInfo startTime={game.startTime} />
          </div>
        </>
      )}
    </div>
  )
}
